import React from 'react';

import { Divider, Radio, RadioChangeEvent, Space } from 'antd';
import { getCountryByLocale } from 'src/utils';

interface SelectLanguageI {
   locale: string;
   lang: string;
   onChangeLocale: (value: string) => void;
   onChangeLang: (value: string) => void;
   onChangeCountry?: (value: string) => void;
}

const SelectLanguage = ({ locale, lang, onChangeLocale, onChangeLang, onChangeCountry }: SelectLanguageI) => {
   const handleChangeLocale = (e: RadioChangeEvent) => {
      const newLocale = e.target.value;
      onChangeLocale(newLocale);
      // Set the country based on the selected locale
      if (onChangeCountry) {
         onChangeCountry(getCountryByLocale(newLocale));
      }
   };

   const handleChangeLang = (e: RadioChangeEvent) => onChangeLang(e.target.value);

   return (
      <div>
         <Radio.Group onChange={handleChangeLocale} value={locale}>
            <Space direction='vertical'>
               <Radio value={'es'}>
                  <Space>
                     <span role='img' aria-label='mx'>
                        🇲🇽
                     </span>
                     {lang === 'es' ? 'México' : lang === 'en' ? 'Mexico' : lang === 'fr' ? 'Mexique' : 'Messico'}
                  </Space>
               </Radio>

               <Radio value={'en'}>
                  <Space>
                     <span role='img' aria-label='eu'>
                        🇺🇸
                     </span>
                     {lang === 'es' ? 'Estados Unidos' : lang === 'en' ? 'United States' : lang === 'fr' ? 'États-Unis' : 'Stati Uniti'}
                  </Space>
               </Radio>

               <Radio value={'es-ES'}>
                  <Space>
                     <span role='img' aria-label='es-ES'>
                        🇪🇸
                     </span>
                     {lang === 'es' ? 'España' : lang === 'en' ? 'Spain' : lang === 'fr' ? 'Espagne' : 'Spagna'}
                  </Space>
               </Radio>

               <Radio value={'co'}>
                  <Space>
                     <span role='img' aria-label='co'>
                        🇨🇴
                     </span>
                     {lang === 'es' ? 'Colombia' : lang === 'en' ? 'Colombia' : lang === 'fr' ? 'Colombie' : 'Colombia'}
                  </Space>
               </Radio>

               <Radio value={'pa'}>
                  <Space>
                     <span role='img' aria-label='pa'>
                        🇵🇦
                     </span>
                     {lang === 'es' ? 'Panamá' : lang === 'en' ? 'Panama' : lang === 'fr' ? 'Panama' : 'Panama'}
                  </Space>
               </Radio>

               <Radio value={'pr'}>
                  <Space>
                     <span role='img' aria-label='pr'>
                        🇵🇷
                     </span>
                     {lang === 'es' ? 'Puerto Rico' : lang === 'en' ? 'Puerto Rico' : lang === 'fr' ? 'Porto Rico' : 'Porto Rico'}
                  </Space>
               </Radio>

               <Radio value={'ar'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇦🇷
                     </span>
                     {lang === 'es' ? 'Argentina' : lang === 'en' ? 'Argentina' : lang === 'fr' ? 'Argentine' : 'Argentina'}
                  </Space>
               </Radio>
               <Radio value={'cr'}>
                  <Space>
                     <span role='img' aria-label='cr'>
                        🇨🇷
                     </span>
                     {lang === 'es' ? 'Costa Rica' : lang === 'en' ? 'Costa Rica' : lang === 'fr' ? 'Costa Rica' : 'Costa Rica'}
                  </Space>
               </Radio>
               <Radio value={'pe'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇵🇪
                     </span>
                     {lang === 'es' ? 'Perú' : lang === 'en' ? 'Peru' : lang === 'fr' ? 'Pérou' : 'Perù'}
                  </Space>
               </Radio>
               <Radio value={'fr'}>
                  <Space>
                     <span role='img' aria-label='fr'>
                        🇫🇷
                     </span>
                     {lang === 'es' ? 'Francia' : lang === 'en' ? 'France' : lang === 'fr' ? 'France' : 'Francia'}
                  </Space>
               </Radio>
               <Radio value={'it'}>
                  <Space>
                     <span role='img' aria-label='it'>
                        🇮🇹
                     </span>
                     {lang === 'es' ? 'Italia' : lang === 'en' ? 'Italy' : lang === 'fr' ? 'Italie' : 'Italia'}
                  </Space>
               </Radio>
               <Radio value={'cl'}>
                  <Space>
                     <span role='img' aria-label='cl'>
                        🇨🇱
                     </span>
                     {lang === 'es' ? 'Chile' : lang === 'en' ? 'Chile' : lang === 'fr' ? 'Chile' : 'Chile'}
                  </Space>
               </Radio>
               <Radio value={'es-UY'}>
                  <Space>
                     <span role='img' aria-label='es-UY'>
                        🇺🇾
                     </span>
                     {lang === 'es' ? 'Uruguay' : lang === 'en' ? 'Uruguay' : lang === 'fr' ? 'Uruguay' : 'Uruguay'}
                  </Space>
               </Radio>
               <Radio value={'es-PY'}>
                  <Space>
                     <span role='img' aria-label='es-PY'>
                        🇵🇾
                     </span>
                     {lang === 'es' ? 'Paraguay' : lang === 'en' ? 'Paraguay' : lang === 'fr' ? 'Paraguay' : 'Paraguay'}
                  </Space>
               </Radio>
               <Radio value={'es-SV'}>
                  <Space>
                     <span role='img' aria-label='es-SV'>
                        🇸🇻
                     </span>
                     {lang === 'es' ? 'El Salvador' : lang === 'en' ? 'El Salvador' : lang === 'fr' ? 'Le Salvador' : 'El Salvador'}
                  </Space>
               </Radio>
            </Space>
         </Radio.Group>
         <Divider />
         <Radio.Group onChange={handleChangeLang} value={lang}>
            <Space direction='vertical'>
               <Radio value={'es'}>{lang === 'es' ? 'Español' : lang === 'en' ? 'Spanish' : lang === 'fr' ? 'Espagnol' : 'Spagnolo'}</Radio>
               <Radio value={'en'}>{lang === 'es' ? 'Inglés' : lang === 'en' ? 'English' : lang === 'fr' ? 'Anglais' : 'Inglese'}</Radio>
               <Radio value={'fr'}>{lang === 'es' ? 'Francés' : lang === 'en' ? 'French' : lang === 'fr' ? 'Français' : 'Francese'}</Radio>
               <Radio value={'it'}>{lang === 'es' ? 'Italiano' : lang === 'en' ? 'Italian' : lang === 'fr' ? 'Italien' : 'Italiano'}</Radio>
            </Space>
         </Radio.Group>
      </div>
   );
};
export default SelectLanguage;
